import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from 'shared/config/env.config';

import { ProfilePasswordFormComponent } from 'shared/profile/profile-password-form/profile-password-form.component';

// uncomment when add methods
import { InviteUserUnguardedService } from 'shared/invite-user/invite-user-unguarded.service';


/**
 *    This class represents the lazy loaded WelcomeComponent.
 */

@Component({
  moduleId: module.id,
  selector: 'accept-invite-cmp',
  templateUrl: 'accept-invite.component.html',
  styleUrls: ['accept-invite.component.scss'],
  // providers: [ProfileInfoService],
})
export class AcceptInviteComponent implements OnInit {

  isCompleted: boolean = false;
  invite: any;

  @ViewChild('profileForm', {static: false}) profileForm: ProfilePasswordFormComponent | void;

  constructor(
    // private profileInfoService: ProfileInfoService,
    protected router: Router,
    private route: ActivatedRoute,
    private inviteUserUnguardedService: InviteUserUnguardedService
  ) {}

  ngOnInit() {
      const { token } = this.route.snapshot.params;
      this.inviteUserUnguardedService.fetch(token)
        .subscribe( (invite) => {
          if (!invite.id) {
            this.router.navigate(['dashboard']);
          }
          this.invite = invite;
        });
  }

  // getters
  get form() {
    return this.profileForm ? this.profileForm.form : null;
  }

  // handlers
  onAcceptInviteClick() {
    if (!this.form || this.form.invalid) { return; }
    const value = this.form.value;
    this.inviteUserUnguardedService.accept(
        this.invite.token,
        this.form.controls['newPassword'].value,
        this.form.controls['newPasswordConfirm'].value,
        this.form.controls['firstName'].value,
        this.form.controls['lastName'].value,
    )
      .subscribe( (res) => {
        this.isCompleted = true;
        this.router.navigate(['/login']);
      });
  }

  onLoginClick() {
    this.router.navigate(['/login']);
  }
}
